export const CUSTOMERS_INITIAL_FILTERS = {
  search: '',
  id: '',
  plan_id: [],
  code_status: '',
  showDeleted: false,
}
